import { createSlice } from '@reduxjs/toolkit'
import { QUOTED } from 'pu-data/QuoteSteps';

import { doUploadProjectFile, doEmailQuoteRequest } from 'pu-utils/bundleProject';
import { doSelectBomFile } from 'pu-utils/BomQuoteApi';
import { bomUploadSuccess } from '../../pcb-parts/data/PartsSlice'
import DefaultState, {
  validateParametersRules,
  aditionalRules,
} from './DefaultState'

const Project = createSlice({
  name: 'projectquote',
  initialState: DefaultState,

  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload
      state.parameters[name] = value
    },
    formValidated(state, action) {
      state.errors = action.payload
    },
    addProjectErrors(state, action) {
      state.projectErrors.push(action.payload)
    },
    cancelProjectErrors(state) {
      state.projectErrors = []
    },
    addProjectWarnings(state, action) {
      state.projectWarnings.push(action.payload)
    },
    cancelProjectWarnings(state) {
      state.projectWarnings = []
    },
    startUploadProjectFile(state) {
      state.loadingZipFile = true
      state.errors = {}
    },
    projectFileUploadSuccess(state, action) {
      state.loadingZipFile = false
      state.errors = {}
      state.directory = action.payload
    },
    projectFileUploadFailure(state, action) {
      state.loadingZipFile = false
      state.parameters.filename = ''
      state.errors = action.payload
    },
    closeZipFileTool(state) {
      state.directory = {}
      state.errors = {}
    },
    openBomFileFailure(state, action) {
      state.errors = action.payload
    },
    updateProjectNumber(state, action) {
      const { bundle_number } = action.payload
      if (bundle_number && bundle_number !== '') {
        state.bundle_rfq_number = bundle_number
      }
    },
  },
})

export const {
  changeParameter,
  formValidated,
  addProjectErrors,
  cancelProjectErrors,
  addProjectWarnings,
  cancelProjectWarnings,
  startUploadProjectFile,
  projectFileUploadSuccess,
  projectFileUploadFailure,
  closeZipFileTool,
  openBomFileFailure,
  updateProjectNumber,
} = Project.actions

const scrollTo = (height) => {
  // eslint-disable-next-line no-undef
  window.scrollTo({
    top: height,
    behavior: 'smooth',
  });
}

const scrollToTop = () => {
  scrollTo(0)
};

const scrollToElement = (id) => {
  const element = document.getElementById(id);
  scrollTo(element.offsetTop)
}

export const scrollToAssembly = () => {
  scrollToElement('pcb-assembly');
};

export const scrollToFabrication = () => {
  scrollToElement('pcb-fabrication');
};

const validateParameters = (parameters) => {
  const errors = {}
  Object.keys(parameters).forEach((key) => {
    if (!validateParametersRules[key]) return;
    const newError = validateParametersRules[key](parameters[key]);
    if (newError) errors[key] = newError
  });

  Object.entries(aditionalRules).forEach(([key, rule]) => {
    const newError = rule(parameters);
    if (newError) errors[key] = newError
  });

  return errors
}

const atLeastOneProject = (assembly, fabrication, parts) => {
  if (assembly.itemSelected || fabrication.itemSelected || parts.itemSelected) {
    return true
  }
  return false
}

const checkParameterChanged = (assembly, fabrication) => {
  if (assembly.itemSelected === true && assembly.parametersChanged === true) {
    return 'PCB Assembly'
  }
  if (fabrication.itemSelected === true && fabrication.parametersChanged === true) {
    return 'PCB Fabrication'
  }
  return null
}

// check if the customer got a quote and dont selecte a price
const checkMissingQuote = (assembly, fabrication) => {
  if (assembly.quoteStep === QUOTED && !assembly.parametersChanged) {
    return 'PCB Assembly'
  }

  if (fabrication.quoteStep === QUOTED && !fabrication.parametersChanged) {
    return 'PCB Fabrication'
  }
  return null;
}

export const addToCart = (parameters, assembly, fabrication, parts) => async (dispatch) => {
  const errors = validateParameters(parameters)
  if (errors && Object.keys(errors).length) {
    dispatch(formValidated(errors))
    scrollToTop()
    return;
  }

  if (!atLeastOneProject(assembly, fabrication, parts)) {
    // alert('seleccione por lo menos un producto')
    dispatch(addProjectErrors('Please select at least one service.'))
    return
  }

  const prmChanged = checkParameterChanged(assembly, fabrication)
  if (prmChanged) {
    // alert(`${prmChanged} ha cambiado un parametro`)
    dispatch(addProjectErrors(`One or more parameter has been changed on ${prmChanged}. Please get a new quote and select a price`))
    return
  }

  const missingQuote = checkMissingQuote(assembly, fabrication)
  if (missingQuote) {
    // alert(`${missingQuote} ha cotizado pero no escogio un precio, desea continuar`)
    dispatch(addProjectWarnings(`${missingQuote} has been quoted but no price was selected. If you continue ${missingQuote} will be discarded`))
    return
  }

  // this submit is also trigger in ProjectWarnings component
  jQuery('#quote_form').submit();
}

export const uploadZipFile = (
  file,
  parameters,
  descompress,
  bundle_number,
  variant_id,
  authToken,
) => async (dispatch) => {
  try {
    dispatch(changeParameter({ name: 'filename', value: file.name }))
    dispatch(startUploadProjectFile())

    const response = await doUploadProjectFile(
      file,
      parameters,
      descompress,
      bundle_number,
      variant_id,
      authToken,
    )

    if (response.code === 200) {
      document.getElementsByName('bundle_number')[0].value = response.bundle_id
      dispatch(updateProjectNumber(response))
      dispatch(projectFileUploadSuccess(response.directory))
    } else {
      // dispatch(projectFileUploadFailure({ upload_file: response.message }))
      dispatch(projectFileUploadFailure({ upload_file: '' }))
    }
  } catch (err) {
    dispatch(projectFileUploadFailure({ upload_file: err.toString() }))
  }
}

export const openBomFile = (bom_file, bundle_number) => async (dispatch) => {
  try {
    const response = await doSelectBomFile(bom_file, bundle_number)
    if (response.code === 400) {
      dispatch(openBomFileFailure({ open_file: response.message }))
    } else {
      dispatch(closeZipFileTool())
      dispatch(bomUploadSuccess(response))
    }

    // bomUploadSuccess
  } catch (err) {
    console.log(err);
  }
}

export const sendEmailQuote = (data, authToken) => async () => {
  try {
    const body = {
      product_quote_email_request: { email: data.email, note: data.note },
      product_quote: {
        variant_id: data.variant_id,
        parameters: data.parameters,
        quote_items: data.quote_items,
      },
    }
    await doEmailQuoteRequest(body, authToken)
  } catch (err) {
    console.error(err)
  }
}

export default Project.reducer
